// Mock data for contact form submission
// This will be replaced with actual backend API calls

export const submitContactForm = async (formData) => {
  // Simulate API call delay
  await new Promise((resolve) => setTimeout(resolve, 1000));

  // Mock validation
  if (!formData.name || !formData.email || !formData.message) {
    throw new Error('Please fill in all required fields');
  }

  // Mock successful response
  console.log('Contact form submitted:', formData);
  
  return {
    success: true,
    message: 'Thank you for your message. We will get back to you soon!',
    data: {
      id: Math.random().toString(36).substr(2, 9),
      timestamp: new Date().toISOString(),
      ...formData,
    },
  };
};

// Mock data for social media (if needed)
export const socialMediaData = {
  facebook: {
    url: 'https://facebook.com/wandaroman',
    posts: [], // Placeholder for Facebook feed
  },
  instagram: {
    url: 'https://instagram.com/wandaroman',
  },
  twitter: {
    url: 'https://twitter.com/wandaroman',
  },
  youtube: {
    url: 'https://youtube.com/@wandaroman',
  },
};
